module.exports = __webpack_public_path__ + "img/display-layouts-screenshot-phone-frame-with-shadow.cc227d1f.png";